// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__U2qFB","Selected":"NavigationItem_Selected__Mn2NW"};